{/* eslint-disable i18next/no-literal-string */}
const ModalHeaderStyles = {
  baseStyle: {
    color: "textDark",
  },
};

export default ModalHeaderStyles;
